









































































































import { defineComponent, computed, PropType, ref, onMounted } from '@vue/composition-api';
import { KnowledgeResultType, SourceDetails, IconListType, guideType } from './type';
import { IconListMap, IconMap } from './const';
import { Message, ReportData, Issue } from '../../../dataType';
import { useRender } from '../../../hooks/useRender';
import { useLocale } from '../../../hooks/useLocale';
import { useIssue } from '../../../hooks/useIssue';
import { parseMarkdownToHtml } from 'zk-editor';
import { findIndex, sortBy } from 'lodash';
import { useInstance } from 'common-module/src/util/useInstance';

export default defineComponent({
  props: {
    message: {
      type: Object as PropType<Message<ReportData<KnowledgeResultType>>>,
      required: true
    }
  },
  setup(props) {
    const { openAside } = useRender();
    const { t, tc } = useLocale();
    const { openIssue } = useIssue();
    const expand = ref(false);
    const reportData:KnowledgeResultType = props.message.content.report.reportData;
    const sourceDetails:SourceDetails = props.message.content.report.reportData.sourceDetails;
    const showSegment = ref(false);
    const TextContainer = ref<HTMLDivElement | null>(null);
    const showSegmentButton = ref(false);
    onMounted(() => {
      if (TextContainer.value && TextContainer.value.getBoundingClientRect().height >= 400) {
        showSegmentButton.value = true;
      }
    });
    const text = computed(() => {
      return parseMarkdownToHtml(reportData.text);
    });
    const keyList = Object.keys(reportData.source) as IconListType[];
    const sourceIdMap = computed(() => {
      return {
        docIds: reportData.source?.doc?.map((item) => item.id) || [],
        issueIds: reportData.source?.issue?.map((item) => item.id) || [],
        attachmentRelIds: reportData.source?.attachment?.map((item) => item.id) || [],
        guide: reportData.source?.guide?.map((item: guideType, index: number) => {
          return {
            ...item,
            id: index
          };
        }) || []
      };
    });

    const singleDetail = computed(() => {
      if (sourceDetails?.docResult?.total === 1) {
        const t = sourceDetails.docResult.data[0];
        const documentDomain = (window as any)?.$config?.VUE_APP_DOCUMENT_SITE_DOMAIN || location.host.replace(/(\w+)/, '$1-docs');
        const path = `${location.protocol}//${documentDomain}/detail/${t.uuid}`;
        return {
          id: t.id,
          type: 'docResult',
          title: t.summary,
          link: path,
          icon: t.issueTypeIcon
        };
      }

      if (sourceDetails?.issueResult?.total === 1) {
        const t = sourceDetails.issueResult.data[0];
        return {
          id: t.id,
          type: 'issueResult',
          title: t.summary,
          link: null,
          icon: t.issueTypeIcon
        };
      }

      if (sourceDetails?.otherResult?.total === 1) {
        const t = sourceDetails.otherResult.data[0] as any;
        const l = t.linkUrl.split('.').pop();
        const isDocument = l in IconMap;
        return {
          id: t.id,
          type: isDocument ? 'otherResult' : 'guide',
          title: t.summary,
          link: t.linkUrl,
          icon: isDocument ? IconMap[l] : IconListMap.guide
        };
      }

      return null;
    });
    const sourceList = computed(() => {
      const l = keyList.map((key) => {
        return {
          key,
          type: key === 'issue' ? 'issueResult' :
            key === 'doc' ? 'docResult' : key === 'guide' ? 'guide' : 'otherResult',
          icon: IconListMap[key],
          ids: reportData.source[key].map((item) => item.id)
        };
      });
      const xl = ['issueResult', 'docResult', 'otherResult'];
      return sortBy(l, x => findIndex(xl, y => y === x.type));
    });

    const openDoc = (link: string) => {
      if (!link) {
        return;
      }
      window.open(
        link,
        '_blank'
      );
    };
    const openAsideComponent = (type: string) => {
      openAside(() => import('../../aside-component/TabList.vue'), {
        ...props.message,
        title: t('saas.robotChat.source'),
        content: {
          ...props.message.content,
          sourceDetails,
          sourceIdMap: sourceIdMap.value,
          targetActiveTab: type
        }
      });
    };

    const openIssueOrDoc = () => {
      const instance = useInstance();
      if (singleDetail.value?.type === 'issueResult') {
        openIssue(singleDetail.value?.id);
        instance?.$track.send('WebIM_ClickAnswerSource', {
          Source_Number: 1,
          Source_Type: 'issue',
          File_types: []
        }, true);
      } else if (singleDetail.value?.type === 'otherResult') {
        const l = singleDetail.value?.link.split('.').pop();
        openDoc(singleDetail.value?.link || '');
        instance?.$track.send('WebIM_ClickAnswerSource', {
          Source_Number: 1,
          Source_Type: 'file',
          File_types: [l]
        }, true);
      } else {
        openDoc(singleDetail.value?.link || '');
        instance?.$track.send('WebIM_ClickAnswerSource', {
          Source_Number: 1,
          Source_Type: 'doc',
          File_types: []
        }, true);
      }
    };

    return {
      t,
      tc,
      toIssue(issue: Issue) {
        if (!issue) {
          return;
        }
        openIssue(issue);
      },
      text,
      expand,
      openIssue,
      sourceList,
      singleDetail,
      openAsideComponent,
      openIssueOrDoc,
      showSegment,
      showSegmentButton,
      TextContainer
    };
  }
});
